import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const ParentalControlsFullIcon: React.FC<OneColorIconProps> = ({ size = 25, color = 'black', className }) => {
  const colorHex = getHexColor(color)
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 52 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.5 24.5001C36.7354 24.5001 35.2248 23.8717 33.9682 22.6151C32.7117 21.3586 32.0833 19.848 32.0833 18.0833C32.0833 16.3188 32.7117 14.8082 33.9682 13.5515C35.2248 12.2949 36.7354 11.6667 38.5 11.6667C40.2645 11.6667 41.7752 12.2949 43.0318 13.5515C44.2883 14.8082 44.9167 16.3188 44.9167 18.0833C44.9167 19.848 44.2883 21.3586 43.0318 22.6151C41.7752 23.8717 40.2645 24.5001 38.5 24.5001ZM25.6667 37.3333V32.8416C25.6667 31.9327 25.9006 31.0971 26.3685 30.3351C26.8363 29.5732 27.458 28.9916 28.2333 28.5906C29.891 27.7618 31.5753 27.1402 33.2865 26.7258C34.9975 26.3114 36.7354 26.1042 38.5 26.1042C40.2645 26.1042 42.0025 26.3114 43.7135 26.7258C45.4247 27.1402 47.109 27.7618 48.7667 28.5906C49.542 28.9916 50.1636 29.5732 50.6315 30.3351C51.0994 31.0971 51.3333 31.9327 51.3333 32.8416V35C51.3333 36.2887 50.2887 37.3333 49 37.3333H25.6667Z"
        fill={colorHex}
      />
      <path
        d="M18.6667 21C21.2333 21 23.7612 21.3019 26.25 21.9046C27.4618 22.1981 28.6638 22.5641 29.8568 23.001C30.3738 23.1904 30.3403 23.9285 29.8215 24.113C28.7547 24.4922 27.7029 24.9413 26.667 25.4593L26.626 25.4821C25.44 26.0955 24.4563 26.9606 23.6979 28.0319L23.3857 28.5036C22.5738 29.826 22.1667 31.2979 22.1667 32.8421V37.3333H2.33333C1.04467 37.3333 0 36.2887 0 35V30.8005C0 29.4785 0.340475 28.2629 1.02083 27.1546C1.70123 26.0466 2.60491 25.1995 3.73242 24.6162C6.14351 23.4107 8.59445 22.5075 11.0833 21.9046C13.5721 21.3019 16.0999 21 18.6667 21Z"
        fill={colorHex}
      />
      <path
        d="M18.6667 0C21.2333 0 23.431 0.913411 25.2588 2.74121C27.0865 4.56902 28 6.76671 28 9.33333C28 11.9001 27.0865 14.0978 25.2588 15.9255C23.431 17.7532 21.2332 18.6667 18.6667 18.6667C16.0999 18.6667 13.9024 17.7532 12.0745 15.9255C10.2469 14.0978 9.33334 11.9001 9.33333 9.33333C9.33333 6.76671 10.2469 4.56902 12.0745 2.74121C13.9024 0.913411 16.0999 0 18.6667 0Z"
        fill={colorHex}
      />
    </svg>
  )
}
